import {DefaultLayout} from "../../../layouts/DefaultLayout";
import React, {useEffect, useRef, useState} from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import InProgress from "../../../components/progress/InProgress";
import FloatingAlert from "../../../components/notifications/FloatingAlert";
import {useParams} from "react-router";
import LoginService from "../../../features/security/LoginService";
import Validator from "../../../features/validation/Validator";
import PartyService from "../../../features/parties/PartyService";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import PasswordGenerator from "../../../features/security/PasswordGenerator";

export default function CreateLoginPage() {
    const navigate = useNavigate()
    const params = useParams()

    // Login
    const passwordRef = useRef(null)
    const [sendEmail, setSendEmail] = useState(false)
    const [sendEmailDisabled, setSendEmailDisabled] = useState(true)

    // Others
    const [lengthOfGeneratedPassword, setLengthOfGeneratedPassword] = useState(0)
    const [inProgress, setInProgress] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('-')

    useEffect(() => {
        setInProgress(true)

        PartyService.getParty(params.partyId)
            .then(r => {
                if (r.data.email?.address)
                {
                    setSendEmailDisabled(false)
                }

                LoginService.getLogin(params.userLoginId)
                    .then(r => {
                        setInProgress(false)
                        
                        if (r.data.roles && r.data.roles.length === 1 && r.data.roles[0] === 'ROLE_USER') {
                            setLengthOfGeneratedPassword(8)
                        } else {
                            setLengthOfGeneratedPassword(20)
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        setInProgress(false)
                        setShowError(true)
                        setErrorMessage(e.response.data.message)
                    })
            })
            .catch(e => {
                console.error(e)
                setInProgress(false)
                setShowError(true)
                setErrorMessage(e.response.data.message)
            })
    }, [params.partyId])

    function createFormData() {
        return {
            password: {
                error: false,
                helperText: ''
            },
        }
    }

    const [formData, setFormData] = useState(createFormData())

    function validate() {
        const newFormData = createFormData()
        let isValid = true
        
        const password = passwordRef.current.value

        if (!Validator.validatePassword(password, true)) {
            newFormData.password.error = true
            newFormData.password.helperText = 'Hasło powininno składać się z co najmniej 8 znakow.'
            isValid = false
        }

        setFormData(newFormData)
        return isValid
    }

    function updatePassword() {
        if (!validate()) {
            return
        }

        setInProgress(true)

        LoginService.updatePassword({
            loginId: params.userLoginId,
            password: passwordRef.current.value,
            sendEmail: sendEmail
        }).then(() => {
            // TODO: dodac informacje o sukcesie
            setInProgress(false)
            navigate('..')
        }).catch(err => {
            console.error(err)
            setInProgress(false)
            setShowError(true)
            setErrorMessage(err.response.data.message)
        })
    }

    return (
        <>
            <DefaultLayout>
                <div id="top">
                    <AppBar id="app-bar" position="sticky">
                        <Toolbar>
                            <IconButton size="large" color="inherit" edge="start"
                                        aria-label="Wróć" aria-haspopup="false"
                                        onClick={() => {
                                            navigate('..')
                                        }}>
                                <ArrowBackIcon/>
                            </IconButton>

                            <Typography variant="h1" sx={{flexGrow: 1}}>
                                Ustaw hasło
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>

                <div id="content-wrapper">
                    <div id="content">
                        <h1>Hasło</h1>

                        <Box component="form" noValidate autoComplete="off" display="block">
                            <Grid container spacing={4}>
                                <Grid item xs={12}>
                                    <TextField label="Hasło"
                                               type="password"
                                               autoComplete="new-password"
                                               fullWidth={true}
                                               inputRef={passwordRef}
                                               error={formData.password.error}
                                               helperText={formData.password.helperText}
                                               InputLabelProps={{
                                                   shrink: true
                                               }}/>
                                </Grid>

                                <Grid item xs={12}>
                                    <Stack direction="row" spacing={2}>
                                        <Button variant="outlined" 
                                                disabled={lengthOfGeneratedPassword === 0} 
                                                onClick={() => {
                                                    passwordRef.current.value = PasswordGenerator
                                                        .generate(lengthOfGeneratedPassword)
                                                }}>Generuj</Button>
                                        <Button variant="outlined" 
                                                onClick={() => {
                                                    navigator.clipboard.writeText(passwordRef.current.value)
                                                }}>Kopiuj</Button>
                                    </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={sendEmail} disabled={sendEmailDisabled}
                                                          onChange={() => setSendEmail(!sendEmail)}/>
                                            }
                                            label="Wyślij e-mail z danymi uwierzytelniania"/>
                                    </FormGroup>
                                </Grid>

                                <Grid item xs={12}>
                                    <Button type={"submit"} variant="contained" size="large" onClick={(e) => {
                                        updatePassword()
                                        e.preventDefault()
                                    }}>
                                        Zapisz
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                </div>

                <FloatingAlert open={showError}
                               severity="error"
                               message={errorMessage}
                               onClose={() => setShowError(false)}/>
                <InProgress open={inProgress}/>
            </DefaultLayout>
        </>
    )
}